import {Button, Space} from "antd"
import {EditOutlined} from "@ant-design/icons"
import type {OrderResponse} from "../../../../../model/response"
import NapasPaymentActions from "../NapasPaymentActions";

interface Props {
  order: OrderResponse
  onEdit: (orderId: string) => void
  onRefreshOrder?: () => void
}

export default function OrderActionsColumn({order, onEdit, onRefreshOrder}: Props) {

  return (
    <Space>
      {/* General Actions */}
      <Button size="small" icon={<EditOutlined/>} onClick={() => onEdit(order.id)}>
        Sửa
      </Button>
      {/* NAPAS Payment Actions - only shows for NAPAS payments */}
      <NapasPaymentActions order={order} onRefreshOrder={onRefreshOrder}/>
    </Space>
  )
}
